export default "__VITE_ASSET__C5kaDon0__"